<template>
  <div
    class="track-timeline"
    :style="{ width: `${trackLengthPx}px`, top: `${top}px` }"
  >
    <div
      v-for="tick in ticks"
      :key="tick.label"
      class="tick"
      :style="{ left: `${tick.left}px` }"
    >
      {{ tick.label }}
    </div>
  </div>
</template>

<script lang="ts">
import { formatTime, WAVEFORM_PIXEL_PER_SEC } from "@/misc";
import { Mix } from "@/models";
import { Options, Vue } from "vue-class-component";
import { mapGetters, mapState } from "vuex";
import { scaleLinear } from "d3";
import { TimelineType } from "@/views/MixView.vue";

@Options({
  props: {
    top: {
      type: Number,
      default: 0,
    },
    timelineType: {
      type: String,
      default: "time",
    },
  },
  computed: {
    ...mapGetters("projects", ["maxLengthMs"]),
    ...mapState("mixes", ["mix"]),
  },
})
export default class TrackTimeline extends Vue {
  maxLengthMs!: number;
  mix!: Mix;
  top!: number;
  timelineType!: TimelineType;

  get trackLengthSec() {
    return this.maxLengthMs / 1000; // Track length in sec
  }

  get trackLengthPx() {
    return this.trackLengthSec * WAVEFORM_PIXEL_PER_SEC;
  }

  get ticks() {
    const tempo = this.mix.tempo;
    const beats = (this.trackLengthSec / 60) * tempo;
    const measures = beats / 4;
    const scale = scaleLinear()
      .range([0, this.trackLengthSec])
      .domain([0, measures]);
    const ticks = [];
    for (let m = 0; m < measures; m++) {
      const sec = scale(m);
      ticks.push({
        left: WAVEFORM_PIXEL_PER_SEC * sec,
        label: this.timelineType === "time" ? formatTime(sec) : m + 1,
      });
    }
    return ticks;
  }
}
</script>

<style lang="scss">
.track-timeline {
  position: absolute;
  top: 0;
  left: 0;
  height: 12px;
  font-size: 0.8em;
  color: black;
  background-color: rgba(0, 0, 0, 0.1);
  user-select: none;
  .tick {
    border-left: 1px solid black;
    padding-left: 4px;
    // text-shadow: 1px 0 1px white, -1px 0 1px white, 0 -1px 1px white,
    // 0 1px 1px white;
    position: absolute;
    top: 0;
  }
}
</style>
